import { SetupContext, computed } from "@vue/composition-api";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { findGetters as findDrinkGetters } from "@dcc/store/drinking/getters";
import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { getActions } from "@dcc/store/drinking/actions";
import { RiskLevel } from "@dcc/types/riskLevel";

export const useDrinkFreeDays = (context: SetupContext) => {
  const {
    getSelectedDrinkFreeDays,
    getAvailableDrinkFreeDays,
    getDrinkFrequency,
    getWeeklyDrinkingDays
  } = findDrinkGetters(context.root.$store);

  const drinkFreeDays = getSelectedDrinkFreeDays();
  const availableDrinkFreeDays = getAvailableDrinkFreeDays();
  const drinkFrequency = getDrinkFrequency().value;
  const weeklyDrinkingDays = getWeeklyDrinkingDays().value;

  const { getRiskLevel } = findScoreGetters(context.root.$store);
  const riskLevel = getRiskLevel().value;

  const { updateDrinkFreeDays } = getActions(context.root.$store);

  const localDrinkFreeDays = computed({
    get: () => {
      return drinkFreeDays.value;
    },
    set: (val) => {
      updateDrinkFreeDays(val);
    }
  });

  const showDrinkFreeDays =
    drinkFrequency === DrinkFrequency.Weekly &&
    riskLevel >= RiskLevel.Increasing &&
    weeklyDrinkingDays.length >= 4;

  return {
    localDrinkFreeDays,
    availableDrinkFreeDays,
    showDrinkFreeDays
  };
};
